import React from 'react';

export const ArrowDown = ({
  width = '10',
  height = '6',
  direction = 'down',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 6"
    fill="none"
    style={{ transform: `rotate(${direction === 'up' ? '180deg' : '0'})` }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.69468 1.39503L5.49468 5.59503C5.22098 5.86873 4.77858 5.86873 4.50488 5.59503L0.304884 1.39503C0.0311844 1.12133 0.0311844 0.678926 0.304884 0.405226C0.578584 0.131526 1.02098 0.131526 1.29468 0.405226L4.99978 4.11033L8.70488 0.405226C8.97858 0.131526 9.42098 0.131526 9.69468 0.405226C9.83118 0.541726 9.89978 0.720926 9.89978 0.900126C9.89978 1.07933 9.83118 1.25853 9.69468 1.39503Z"
      fill="white"
    />
  </svg>
);
